import refurbisherTranslations from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisherAdapter.translations'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import {
  type BuyBackQuoteListing,
  LISTING_PUBLICATION_STATE,
} from '~/api/quotes/types'

import { type BuyBackListingsGroup, GROUP_IDS } from '../../WishList.types'

export function groupListingsByStatus(
  listings: BuyBackQuoteListing[],
): BuyBackListingsGroup[] {
  const i18n = useI18n()

  const isOnline = (listing: BuyBackQuoteListing) =>
    listing.state === LISTING_PUBLICATION_STATE.ONLINE
  const isOffline = (listing: BuyBackQuoteListing) =>
    listing.state === LISTING_PUBLICATION_STATE.OFFLINE

  const listingsWithoutBackbox: BuyBackQuoteListing[] = []
  const listingsWithBackbox: BuyBackQuoteListing[] = []
  const listingsOffline: BuyBackQuoteListing[] = []

  listings.forEach((listing) => {
    if (isOnline(listing) && !listing.hasBackbox) {
      listingsWithoutBackbox.push(listing)
    }

    if (isOnline(listing) && listing.hasBackbox) {
      listingsWithBackbox.push(listing)
    }

    if (isOffline(listing)) {
      listingsOffline.push(listing)
    }
  })

  return [
    {
      id: GROUP_IDS.WITHOUT_BACKBOX,
      title: i18n(refurbisherTranslations.withoutBackboxLabel),
      listings: listingsWithoutBackbox,
    },
    {
      id: GROUP_IDS.WITH_BACKBOX,
      title: i18n(refurbisherTranslations.withBackboxLabel),
      listings: listingsWithBackbox,
    },
    {
      id: GROUP_IDS.OFFLINE,
      title: i18n(refurbisherTranslations.offlineLabel),
      listings: listingsOffline,
    },
  ]
}
